export const generateToBase64 = (data: any) => {
    const jsonString = JSON.stringify(data);

    // Encode JSON string to Base64
    const base64String = btoa(jsonString);

    return base64String;
};
export const reverseBase64 = (base64String: any) => {
    // Decode Base64 to JSON string
    const jsonString = atob(base64String);

    // Parse JSON string to object
    const obj = JSON.parse(jsonString);

    return obj;
};
